//@ts-nocheck
/*
 *  This file routing-constant.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import * as _ from 'lodash';

import { MENU_CODES } from './menu-codes.constant';

export interface NavObject {
  code: string;
  path: string;
}

export const productManagementDashboardRouting: NavObject[] = [
  {
    code: MENU_CODES.DASHBOARD.HOME,
    path: '/product-management/home'
  },
];

export const setUpRouting: NavObject[] = [
  {
    code: MENU_CODES.DASHBOARD.SETUP,
    path: '/product-management/setup'
  },
  {
    code: MENU_CODES.SETUP.USER,
    path: '/product-management/setup/user'
  },
  {
    code: MENU_CODES.SETUP.ANNOUNCEMENT,
    path: '/product-management/setup/announcement'
  },
  {
    code: MENU_CODES.SETUP.PAGE_ACCESS_RIGHTS,
    path: '/product-management/setup/page-access'
  },
  {
    code: MENU_CODES.SETUP.SERVICES,
    path: '/product-management/setup/services'
  },
  {
    code: MENU_CODES.SETUP.EVENT,
    path: '/product-management/setup/event'
  },
  {
    code: MENU_CODES.SETUP.HR_NPS,
    path: '/product-management/setup/hr-nps'
  },
  {
    code: MENU_CODES.SETUP.EMPLOYEE_NPS,
    path: '/product-management/setup/employee-nps'
  },
  {
    code: MENU_CODES.SETUP.SERVICEDASHBOARD,
    path: '/product-management/setup/service-dashboard'
  },
  {
    code: MENU_CODES.SETUP.ADOPTION_REQUESTS,
    path: '/product-management/setup/adoption-requests'
  },
  {
    code: MENU_CODES.SETUP.CUSTOMER_OVERVIEW,
    path:'/product-management/setup/customer-overview'
  },
  {
    code: MENU_CODES.SETUP.USAGE,
    path:'/product-management/setup/usage'
  },
  {
    code: MENU_CODES.SETUP.TEAMPERFORMANCE,
    path:'/product-management/setup/team-performance'
  },
   {
    code: MENU_CODES.SETUP.CUSTOMER,
    path:'/product-management/setup/customer'
  },
  {
    code: MENU_CODES.SETUP.PENDING_CUSTOMER,
    path:'/product-management/setup/pending-customer'
  },
  {
    code: MENU_CODES.SETUP.LEAD_CUSTOMER,
    path:'/product-management/setup/lead-customer'
  },
  {
    code: MENU_CODES.SETUP.FREE_CUSTOMER,
    path:'/product-management/setup/free-customer'
  },
  {
    code: MENU_CODES.SETUP.CUSTOMER_DISCOUNT,
    path:'/product-management/setup/customer-discount'
  },
  {
    code: MENU_CODES.SETUP.USAGE_ALERT,
    path:'/product-management/setup/alerts'
  },
  {
    code: MENU_CODES.SETUP.BENEFIT_OFFER,
    path:'/product-management/setup/benefit-offers'
  },
  {
    code: MENU_CODES.SETUP.INVOICE,
    path:'/product-management/setup/invoice/grid'
  },
  {
    code: MENU_CODES.SETUP.CREDIT,
    path:'/product-management/setup/credit/grid'
  },
  {
    code: MENU_CODES.SETUP.REPORT,
    path:'/product-management/setup/report'
  },
  {
    code: MENU_CODES.SETUP.RENEW_SUBSCRIPTION,
    path:'/product-management/setup/renew-subscription'
  },
  {
    code: MENU_CODES.SETUP.MARKET_PLACE,
    path: '/product-management/setup/market-place'
  },
];

export const superUserMenuNavigationModel = _.concat(productManagementDashboardRouting, setUpRouting);
